<!-- NOTE: The name of this component is bad -->
<template lang="html">
  <fullscreen-overlay-layout
    :pageWidth="tab === 'class-wide' ? '750px' : '1200px'"
    :centeredTitle="true"
    @close="$emit('close')"
    :title="getCurrentDiscussion.title"
  >
    <div v-if="hasTeacherPermissionsInCourse">
      <pl-button
        @click.native="tab = 'class-wide'"
        :class="getBtnClass('class-wide')"
        style="color: black"
      >
        <img
          src="/static/live_discussion/polls.svg"
          alt=""
          height="18px"
          width="22px"
        />
        <span> Class-wide </span>
      </pl-button>
      <pl-button
        @click.native="tab = 'individual'"
        :class="getBtnClass('individual')"
        style="width: 130px; color: black"
      >
        <img src="/static/live_discussion/individual.svg" alt="" />
        <span> Individual </span>
      </pl-button>
    </div>
    <div v-if="show_spinner" class="flex justify-center">
      <pl-spinner />
    </div>
    <template v-else>
      <template v-if="tab === 'class-wide'">
        <div>
          <participation-counter />
          <span class="pl-display-1">Participation Rate</span>
        </div>
        <div class="vertical-line"></div>
        <div>
          <pl-menu :menuSize="8" direction="right">
            <pl-button
              slot="menu_trigger"
              class="pl-display-1 flex flex-nowrap items-center no-padding"
              style="color: #43484c"
            >
              <span>{{ time_spent.content }}</span>
              <i class="fa fa-caret-down fa-xs pl3" aria-hidden="true" />
            </pl-button>
            <ul menu-content>
              <li @click="getTimeSpent('tapped-in', 'Time spent tapped in')">
                <span
                  class="time-spent-span"
                  :class="{ checkmark: time_spent.key === 'tapped-in' }"
                >
                  Time spent tapped in
                </span>
                <i
                  v-if="time_spent.key === 'tapped-in'"
                  class="fa fa-check checkmark"
                  aria-hidden="true"
                />
              </li>
              <li @click="getTimeSpent('as-speaker', 'Time spent as speaker')">
                <span
                  class="time-spent-span"
                  :class="{ checkmark: time_spent.key === 'as-speaker' }"
                  >Time spent as speaker</span
                >
                <i
                  v-if="time_spent.key === 'as-speaker'"
                  class="fa fa-check checkmark"
                  aria-hidden="true"
                />
              </li>
            </ul>
          </pl-menu>
          <aster-plot
            :time_spent_key="time_spent.key"
            :key="componentKey"
            class="mv5"
          />
          <div
            v-my-tooltip.bottom="configTooltip(reflections.time_in_circle)"
            class="reflection-text"
          >
            Reflection Questions
          </div>
        </div>

        <div class="vertical-line"></div>

        <div>
          <tap-in-counter />
          <span class="pl-display-1">Tap-ins per student</span>
        </div>

        <div class="vertical-line"></div>

        <!-- Class Wide Tap In breakdown -->
        <div class="row no-margin no-padding center-xs">
          <div class="col-xs-3">
            <div class="turn_count primary-colour">
              {{ turn_count_by_type.new_idea || 0 }}
            </div>
            <div class="pl-headline">New Ideas</div>
          </div>
          <div class="col-xs-3">
            <div class="turn_count ruby-colour">
              {{ turn_count_by_type.challenge || 0 }}
            </div>
            <div class="pl-headline">Challenges</div>
          </div>
          <div class="col-xs-3">
            <div class="turn_count green-colour">
              {{ turn_count_by_type.build_on || 0 }}
            </div>
            <div class="pl-headline">Build Ons</div>
          </div>
          <div class="col-xs-3">
            <div class="turn_count black-colour">
              {{ turn_count_by_type.question || 0 }}
            </div>
            <div class="pl-headline">Questions</div>
          </div>
        </div>

        <!-- Suggestions -->
        <div class="mt4 pl-title tl">
          <div v-for="(suggestion, index) in suggestions" class="mb4">
            <span class="b">Suggestion {{ index + 1 }} - </span>
            <span v-html="suggestion.text"></span>
            <div class="why-this-suggestion ruby-colour pl-caption">
              Why this suggestion?
              <span class="suggestion-tooltip pl-caption">{{
                suggestion.explanation
              }}</span>
            </div>
          </div>
        </div>
        <div
          v-my-tooltip.bottom="configTooltip(reflections.total_tap_ins)"
          class="reflection-text"
        >
          Reflection Questions
        </div>

        <div class="vertical-line"></div>

        <div :class="[show_full_tap_in_summary ? 'expanded' : 'collapsed']">
          <span class="pl-display-1">Tap-In Summary</span>
          <horizontal-stacked-bar class="mt3" />
        </div>
        <div class="mb4">
          <p
            class="pl-title expand-btn"
            @click="show_full_tap_in_summary = !show_full_tap_in_summary"
          >
            {{ show_full_tap_in_summary ? 'Hide' : 'Expand All' }}
          </p>
        </div>
        <div
          v-my-tooltip.bottom="configTooltip(reflections.bar_chart)"
          class="reflection-text mb6"
        >
          Reflection Questions
        </div>
      </template>
      <template v-else>
        <individual-summary-overlay
          :table_data="table_data"
          @close="$emit('close')"
        />
      </template>
    </template>
  </fullscreen-overlay-layout>
</template>

<script>
  import FullscreenOverlayLayout from 'components/fullscreenOverlay';
  import { mapGetters } from 'vuex';
  import reflections from './reflectionQuestions';
  // D3 Data Visualization
  import asterPlot from 'components/dataVisualization/d3js/asterPlot';
  import horizontalStackedBar from 'components/dataVisualization/d3js/horizontalStackedBar';
  import participationCounter from 'components/dataVisualization/d3js/participationCounter';
  import tapInCounter from 'components/dataVisualization/d3js/tapInCounter';
  import liveDiscussionService from 'services/liveDiscussion';
  import IndividualSummaryOverlay from './individualSummaryOverlay.vue';

  const question_suggestion = {
    text: `Try to ask more questions during the discussion.
    <a class="p-anchor" href="https://parlayideas.com/wp-content/uploads/2019/06/Ask-Questions.pdf" target="_blank">Click here</a>
    to download a resource to review examples and sentence stems.`,
    explanation:
      'There were less than half the number of questions than the most used turn type.',
  };
  const challenge_suggestion = {
    text: `Try to respectfully challenge each other’s ideas more during the discussion.
    <a class="p-anchor" href="https://parlayideas.com/wp-content/uploads/2019/06/Challenge-Ideas.pdf" target="_blank">Click here</a>
    to  download a resource to review examples and sentence stems.`,
    explanation:
      'There were less than half the number of challenges than the most used turn type.',
  };
  const new_idea_suggestion = {
    text: `Try introducing more new ideas during the discussion.
    <a class="p-anchor" href="https://parlayideas.com/wp-content/uploads/2019/06/New-Idea.pdf" target="_blank">Click here</a>
    to download a resource to review examples and sentence stems.`,
    explanation:
      'There were less than half the number of new ideas than the most used turn type.',
  };
  const build_on_suggestion = {
    text: `Try building on each other’s ideas more during the discussion.
    <a class="p-anchor" href="https://parlayideas.com/wp-content/uploads/2019/06/Build-on-Ideas.pdf" target="_blank">Click here</a>
    to download a resource to review examples and sentence stems.`,
    explanation:
      'There were less than half the number of build-ons than the most used turn type.',
  };

  export default {
    data() {
      return {
        show_spinner: true,
        show_full_tap_in_summary: false,
        tab: 'class-wide',
        time_spent: { key: 'tapped-in', content: 'Time spent tapped in' },
        componentKey: 0,
      };
    },
    components: {
      FullscreenOverlayLayout,
      asterPlot,
      IndividualSummaryOverlay,
      horizontalStackedBar,
      participationCounter,
      tapInCounter,
    },
    computed: {
      ...mapGetters([
        'hasTeacherPermissionsInCourse',
        'getCurrentDiscussion',
        'getClassSummaryLD',
      ]),
      reflections() {
        return reflections;
      },

      turn_types_below_threshold() {
        // Clone the object
        const cloned = JSON.parse(JSON.stringify(this.turn_count_by_type));
        delete cloned.hand_raise;

        // Extract the maximum value to compare against
        const values = Object.values(cloned);
        const max_value = Math.max(...values);

        // Iterate Over Object to see which values are below half of the max value
        const matched_turn_types = [];
        Object.entries(cloned).forEach((entry) => {
          const key = entry[0];
          const value = entry[1];
          if (value / max_value < 0.5) {
            matched_turn_types.push(key);
          }
        });
        return matched_turn_types;
      },
      suggestions() {
        const { turn_types_below_threshold } = this;
        const suggestions = [];
        if (turn_types_below_threshold.includes('question')) {
          suggestions.push(question_suggestion);
        }
        if (turn_types_below_threshold.includes('challenge')) {
          suggestions.push(challenge_suggestion);
        }
        if (turn_types_below_threshold.includes('new_idea')) {
          suggestions.push(new_idea_suggestion);
        }
        if (turn_types_below_threshold.includes('build_on')) {
          suggestions.push(build_on_suggestion);
        }
        return suggestions;
      },
      turn_count_by_type() {
        const turn_data = {
          question: 0,
          challenge: 0,
          new_idea: 0,
          build_on: 0,
          hand_raise: 0,
        };

        this.getClassSummaryLD.all_turns.forEach((turn) => {
          if (turn_data[turn.turn_type]) {
            turn_data[turn.turn_type] += 1;
          } else {
            turn_data[turn.turn_type] = 1;
          }
        });
        return turn_data;
      },
    },
    methods: {
      configTooltip(reflection_text) {
        return {
          content: reflection_text,
          classes: 'large-tooltip',
        };
      },
      createTableObject(participant) {
        let result = {};
        result.name = participant.name;
        result.avatar = participant.image;
        result.studentID = participant.participation_id;
        result.tap_ins = {
          time_as_speaker: participant.time_spent_as_current_speaker,
          total: participant.total_contributions,
          new_idea: participant.new_idea,
          build_on: participant.build_on,
          challenge: participant.challenge,
          question: participant.question,
          teacher: participant.hand_raise,
        };
        result.feedback = {
          complete: participant.teacher_feedback !== '' ? 'yes' : 'no', // get teacher feedback for that student (need id)
          //response: '-', // get student response feedback for teacher
        };
        return result;
      },
      getBtnClass(selected) {
        return selected === this.tab ? 'btn-text selected' : 'btn-text';
      },
      fetchClassSummary() {
        const live_id = this.$route.params.liveDiscussionID;
        this.$store.dispatch(
          'analytics',
          'teacher - access verbal discussion metrics'
        );
        return liveDiscussionService
          .classSummaryLD(live_id)
          .then((response) => {
            this.$store.dispatch('postClassSummaryLD', response.data);
          })
          .catch((err) => {
            console.error(err);
          });
      },
      getTimeSpent(key, value) {
        this.time_spent.key = key;
        this.time_spent.content = value;
        this.forceRerender();
      },
      forceRerender() {
        this.componentKey += 1;
      },
    },
    created() {
      //this.fetchClassCSVdata();
      liveDiscussionService
        .getSummaryTableData(this.getCurrentDiscussion.id)
        .then((res) => {
          this.table_data = res.data;
          this.table_data = this.table_data.map((participant) =>
            this.createTableObject(participant)
          );
        });
    },
    mounted() {
      this.fetchClassSummary().then(() => {
        this.show_spinner = false;
      });
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'

  .reflection-text
    color: pl-primary
    font-weight: 500
    font-size: 16px
    margin-top: 25px

  .btn-text
    display:inline-block;
    color:black
    padding-bottom:2px;
    &.selected
      border-bottom:3px solid black;
      font-weight:bold

  .why-this-suggestion {
    position: relative;
    // display: inline-block;
  }

  /* Tooltip text */
  .why-this-suggestion .suggestion-tooltip {
    visibility: hidden;
    max-width: 300px;
    background-color: #43484C;
    color: #fff;
    text-align: center;
    padding: 15px;
    border-radius: 6px;

    position: absolute;
    z-index: 5;
  }

  /* Show the tooltip text when you mouse over the tooltip container */
  .why-this-suggestion:hover .suggestion-tooltip {
    visibility: visible;
  }

  .primary-colour
    color: pl-primary
  .ruby-colour
    color: pl-ruby
  .green-colour
    color: #157F1F
  .black-colour
    color: #273248

  .turn_count
    font-weight: bold
    font-size: 35px
    margin-bottom: 10px

  .vertical-line
    width: 50%
    border-right: 0.1em solid alpha(pl-slate, 0.4)
    height: 6em
    margin: 6em auto 6em 0em

  .collapsed
    min-height: 200px
    max-height: 460px
    overflow: hidden
    -moz-transition: all .9s
    -o-transition: all .9s
    -webkit-transition: all .9s
    transition: all .9s

  .expanded
    min-height: 200px
    max-height: 3000px
    overflow: visible
    -moz-transition: all .9s
    -o-transition: all .9s
    -webkit-transition: all .9s
    transition: all .9s

  .expand-btn
    text-decoration: underline
    cursor: pointer

  .checkmark
    color: pl-primary

  .time-spent-span
    font-size: 24px
</style>



// WEBPACK FOOTER //
// classSummaryOverlay.vue?5765a86d